<template>
  <div id="summary" class="section">
    <div class="box">
      <h1 class="title">Response Submission</h1>
      <div v-if="testId === 2">
        <p>Submit your response and check your results.</p>
        <button class="button is-large" :class="{ 'is-loading': isLoadingSubmit }" @click="submitYourResponse()" :disabled="isResultSubmitted">Submit</button>
        <br />
        <SessionInfo />
        <br />
        <p>Thanks for taking the tests. Please click the button below to check your results.</p>
        <br />
        <div class="has-text-centered" v-if="isResultSubmitted">
          <button class="button is-info is-medium" @click="checkResults()">Check My Results</button>
        </div>
      </div>
      <div v-if="testId === 3">
        <p>பதில்களின் பதிவு: உங்கள் பதில்களின் முடிவுகளை தெரிந்துகொள்ள கீழேயுள்ள சப்மிட் பட்டன்னை கிளிக் செய்யவும்</p>
        <br />
        <button class="button is-large" :class="{ 'is-loading': isLoadingSubmit }" @click="submitYourResponse()" :disabled="isResultSubmitted">Submit</button>
        <br />
        <SessionInfo />
        <br />
        <p>Thanks for taking the tests. Please click the button below to check your results.</p>
        <br />
        <div class="has-text-centered" v-if="isResultSubmitted">
          <button class="button is-info is-large" @click="checkResults()">முடிவுகளை தெரிந்துகொள்ளுங்கள்</button>
        </div>
      </div>
      <div v-if="testId === 6">
        <p>Submit your response and check your results.</p>
        <button class="button is-large" :class="{ 'is-loading': isLoadingSubmit }" @click="submitYourResponse()" :disabled="isResultSubmitted">Submit</button>
        <br />
        <SessionInfo />
        <br />
        <p>Thanks for taking the tests. Please click the button below to check your results.</p>
        <br />
        <div class="has-text-centered" v-if="isResultSubmitted">
          <button class="button is-info is-medium" @click="checkResults()">Check My Results</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SessionInfo from './SessionInfo';

export default {
  name: 'summary-info',
  components: {
    SessionInfo,
  },
  props: {
    response: Array,
    question: Array,
  },
  data() {
    return {
      isResultSubmitted: false,
      userId: this.$temp.sessionCode,
      testId: +this.$temp.testId,
      isLoadingSubmit: false,
      showResults: false,
    };
  },
  methods: {
    checkResults() {
      this.$router.push('/results');
    },
    submitYourResponse() {
      this.isLoadingSubmit = true;
      this.$http
        .post('/scarf/submitAnswers', {
          sessionCode: this.userId,
          testId: this.testId,
          responses: this.response,
        })
        .then((res) => {
          this.isLoadingSubmit = false;
          if (res.data.ok === 1) {
            this.$toast.open(res.data.msg);
            this.isResultSubmitted = true;
          } else {
            this.$toast.open(res.data.msg);
            this.isResultSubmitted = false;
          }
        });
    },
  },
  created() {
    if (!this.$temp.sessionCode) {
      this.$toast.open('Your session ended. Enter your organization code and try again.');
      this.$router.push('/');
    }
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Summary.vue